<template>
    <footer>
        <div class="page-box-layout">
            <div class="logo">
                <img src="@/assets/img/logo.png" />
            </div>
            <div class="info">
                <div class="title">联系我们</div>
                <div class="row">
                    <span>联系邮箱</span>
                    <p>release-help@taihe.com</p>
                </div>
                <div class="row">
                    <span>公司地址</span>
                    <!-- <p>北京朝阳区三里屯西五街5号院C座太合音乐</p> -->
                    <p>北京朝阳区八里庄街道莱锦文化创意产业园CN07太合音乐集团</p>
                </div>
            </div>
            <div class="cooperation">
                <div class="partner">
                    <a href="https://www.taihe.com/" target="_blank">
                        <img src="@/assets/img/partner-1.png" />
                    </a>
                    <a href="https://www.showstart.com/" target="_blank">
                        <img src="@/assets/img/partner-2.png" />
                    </a>
                    <!-- <a href="https://music.taihe.com/" target="_blank">
                        <img src="@/assets/img/partner-3.png" />
                    </a> -->
                    <a href="https://www.lavaradio.com/" target="_blank">
                        <img src="@/assets/img/partner-4.png" width="108px" />
                    </a>
                </div>
                <div class="text">
                    <div class="beian-area">
                        <span class="footer-text">太合音乐集团 ©2021成都太合乐动科技有限公司 版权所有</span>
                        <a href="https://beian.miit.gov.cn" rel="noreferrer" target="_blank">蜀ICP备14016442号-11</a>
                        <img src="@/assets/img/beian.png" alt="" width="16px" height="16px" />
                        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=51019002009628" rel="noreferrer" target="_blank">川公网安备51019002009628号</a>
                    </div>
                    <!-- 网络文化经营许可证编号：
                    <router-link to="/help?key=qualification">川网文（2020）1284-235号</router-link>
                    <br /> -->
                    营业性演出许可证：510000120277 
                    <!-- | 增值电信业务经营许可证编号：
                    <router-link to="/help?key=qualification">川B2-20180527</router-link> -->
                    <br />
                    出版物经营许可证：成新出发高新字第004号 | 12318全国文化市场举报平台
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
footer {
    background: #f6f6f6;
    padding: 120px 0 160px;
    .page-box-layout {
        display: flex;
        .logo {
            width: 124px;
            height: 36px;
            margin-right: 100px;
            img {
                width: 100%;
                display: block;
            }
        }
        .info {
            margin-right: 135px;
            width: 234px;
            .title {
                color: #3a3a3a;
                font-weight: bold;
                line-height: 21px;
            }
            .row {
                font-size: 12px;
                font-weight: 600;
                line-height: 21px;
                margin-top: 22px;
                span {
                    color: #909090;
                }
                p {
                    color: #3a3a3a;
                }
            }
        }
        .cooperation {
            flex: 1;
            .partner {
                padding-bottom: 64px;
                border-bottom: 2px solid #dee1e7;
                a {
                    margin-right: 52px;
                }
            }
            .text {
                font-size: 11px;
                font-weight: 600;
                color: #bcbcbc;
                line-height: 25px;
                margin-top: 20px;
                .beian-area {
                    display: flex;
                    .footer-text {
                        margin-right: 10px;
                    }
                    img {
                        margin-right: 5px;
                    }
                }
            }
        }
    }
}
</style>
